var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("LfHeaderTitleComponent", {
        staticClass: "header-title",
        attrs: { title: _vm.$t("views.billing_provider_invoices.title") },
      }),
      _vm.totals && _vm.totals.length
        ? _c("LfTotalsComponent", { attrs: { items: _vm.totals } })
        : _vm._e(),
      _vm.renderGrid && !_vm.showSpinnerLayer
        ? _c("GridTable", {
            ref: "grid",
            attrs: {
              itemsData: _vm.billingDataFormatted,
              gridConfiguration: _vm.listConfig,
              listName: _vm.listName,
              toolbarOptions: _vm.toolbarOptionsCustom,
              contextMenuItems: _vm.invoiceContextMenuItems,
              context: _vm.context,
              archivedFilter: _vm.archivedSelectedOption,
              activeOnClickCell: _vm.selectedOnlyOneInvoice,
              checkboxSelectColumn: _vm.showCheckboxSelectColumn,
              showFirstColumn: _vm.showCheckboxSelectColumn,
              frozenColumns: _vm.isPortalUser ? 1 : 3,
              excelExportedFileName: "Facturas Proveedores",
            },
            on: {
              contextMenuClicked: _vm.onContextMenuClicked,
              gridTableFilter: _vm.onGridTableFilter,
              toolbarClicked: _vm.onToolbarClicked,
              selectedRecords: _vm.onSelectedRecords,
              contextMenuBeforeOpen: _vm.onContextMenuBeforeOpen,
              customToolbarContextMenuClick:
                _vm.onCustomToolbarContextMenuClick,
            },
          })
        : _vm._e(),
      _c("ejs-contextmenu", {
        staticClass: "context-menu-component e-contextmenu-archived",
        attrs: {
          id: _vm.idContextMenu,
          items: _vm.invoicesArchivedContextMenuItemsParsed,
          select: _vm.onInvoicesArchivedClick,
        },
      }),
      _c("PrintOrSaveInvoicesDialog", {
        attrs: {
          showDialog: _vm.showTemplateDialog,
          idEntityType: _vm.idEntityType,
        },
        on: {
          closePrintOrSaveInvoiceDialog: _vm.closeTemplateDialog,
          generateTemplateDialog: _vm.generateTemplateDialog,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }